import type { WeeklyNoteSaved } from "@msc/shared";

import { LiveNoteField } from "./LiveNoteField.js";
import { useLive } from "./LiveKontext.js";
import { NoteField } from "./NoteField.js";

/**
 * Ein Notizfeld des Weeklies: im Live-Raum gemeinsam bearbeitet (#305), sonst
 * mit Autosave über die REST-Route wie bisher. Bis der erste Abgleich steht,
 * bleibt es beim Bisherigen — ein Feld, das erst leer und dann voll ist, wäre
 * schlimmer als eines, das eine Sekunde später live wird.
 */
export function NotizFeld({
  feld,
  label,
  value,
  version,
  readOnly,
  save,
  onConflict,
}: {
  /** `general`, `c:<customerId>` oder `p:<prospectId>` — derselbe Schlüssel wie im Raum; `null` = nie live. */
  feld: string | null;
  label?: string;
  value: string;
  version: number;
  readOnly: boolean;
  save: (vars: { notes: string; version: number }) => Promise<WeeklyNoteSaved>;
  onConflict: () => void;
}) {
  const live = useLive();
  if (live?.modus === "live" && feld) return <LiveNoteField live={live} feld={feld} label={label} readOnly={readOnly} />;
  return <NoteField label={label} value={value} version={version} readOnly={readOnly} save={save} onConflict={onConflict} />;
}

/** Feldschlüssel einer Zeile, wie ihn der Server bildet (`feldFuer` in weeklyLive.ts). */
export function feldDerZeile(zeile: { customerId: string | null; prospectId: string | null }): string | null {
  if (zeile.customerId) return `c:${zeile.customerId}`;
  if (zeile.prospectId) return `p:${zeile.prospectId}`;
  return null;
}
